import VidModal from 'main/media/vid-modal';
import ImageModal from 'main/media/image-modal';


/**
 * Media Functionality
 */
( function Media() {

    // Initialize video backgorunds
    $(window).load( () => {

      videoBackgrounds();
      VidModal.init();
      ImageModal.init();
      setupLightGalleries();
      //setupGalleries();

    } );

    /**
     * Setup the lightgalliers
     */
    function setupLightGalleries() {

      //const $galleries = document.querySelectorAll( '[data-js-img-gallery]' );
      const $galleries = $('[data-js-gallery]');

      if( ! $galleries.length ) {
        return;
      }

      $galleries.lightGallery({
        selector: '[data-js-gallery-single]',
        exThumbImage: 'data-thumb'
      } );

    }

    /**
     * Setup galleries.
     */
    // function setupGalleries() {

    //   const $gallery_items = $('[data-js-gallery-single]');
    //   const gallery_nav_att = 'data-js-gallery-nav';
    //   const $gallery_nav = $(`[${gallery_nav_att}]` );

    //   galleryNav();


    //   /**
    //    * Gallery navigation
    //    */
    //   function galleryNav() {

    //     $gallery_nav.on( 'click', event => {
    //       event.preventDefault();

    //       const $target = $( event.target );
    //       const direction = $target.attr( gallery_nav_att );
    //       const $this_item = $target.parents( '[data-js-gallery-single]' );
    //       const $this_item_close = $this_item.find( '.l-modal__close' );
    //       const this_index = parseInt( $this_item.attr( 'data-js-gallery-single' ) );

    //       let target_index = '';

    //       // Go to previous item
    //       if( direction == 'prev' ) {
  
    //         target_index = this_index - 1;

    //       }
    //       // Go to next item
    //       else if( direction == 'next' ) {

    //         target_index = this_index + 1;

    //       }

    //       // Make target modal active
    //       VidModal.closeModal();
    //       ImageModal.closeModal();



    //          $(`[data-js-gallery-single=${target_index}]`).trigger( 'click' );
    //          console.log( 'click' );
      
         

    //     } );

    //   }
    // }

    /**
     * Video Backgrounds
     */
    function videoBackgrounds() {

        var $autoplay_containers = $('[data-js-autoplay-bg]');

        if( $autoplay_containers.length ) {

          $autoplay_containers.each( function( index ) {

              loadVideos( index, $(this) );

          } );

        }



        /**
         * Autoplay video on scroll
         */
        function loadVideos( index, $container ) {


          // Create iframe once user scrolls close to container
          //$(window).scroll( function() {

            //if( $(window).scrollTop() + $(window).height() + 600 >= $container.offset().top ) {

              // Stop if we have already initialized a vid for this container
              if( $container.hasClass( 'has-initialized-vid' ) ) {
                return;
              }

              $container.addClass( 'has-initialized-vid' );

              var src = $container.attr( 'data-js-vid-url' );

              // Load youtube iframe
              if( src.indexOf( 'youtube' ) >= 0 )  {

                loadYoutubeVideo( $container );

              }
              // Load Vimeo
              else if( src.indexOf( 'vimeo' ) >= 0 ) {
                
                loadVimeoVideo( $container );

              }


          // } 

          //} );
        }

        /**
         * Load YouTube video
         */
        function loadYoutubeVideo( $container ) {

          var youtube_api_ready = true;

          if( typeof( window.YT ) == 'undefined' || typeof( window.YT.Player ) == 'undefined' ) {

            youtube_api_ready = false;

          }

          if(  ! youtube_api_ready && typeof window.onYouTubePlayerAPIReady == 'undefined' ) {

            window.onYouTubePlayerAPIReady = function() {

              youtubeAPIEvents();

            }
          }    

          var player;
          var src = $container.attr('data-js-vid-url');
          var vid_id = src.slice( src.indexOf( 'embed/' ) + 6, src.lastIndexOf( '?' ) );
          var container_styles = '';

          if( $(document).width() < 768 ) {

            container_styles += 'display: none; ';

          }

          var $html = '<div id="' + vid_id + '" style="' + container_styles + '"></div>';

          // If youtube api is not loaded, load it!
          if( ! youtube_api_ready ) {

            $html += '<script src="https://www.youtube.com/iframe_api">';
            $html += '</script>';

          }

          // Add iframe to the video container
          $container.children( '.inner' ).prepend( $html );


          // Indicate that video is playing
          $container.addClass('is-playing');

        };


        /**
        *  YouTube  API is ready
        */
        function youtubeAPIEvents( ) {

          var vid_ids = [];

          $autoplay_containers.each( ( index, container ) => {

            let src = $(container).attr('data-js-vid-url');
            let vid_id = src.slice( src.indexOf( 'embed/' ) + 6, src.lastIndexOf( '?' ) );

            vid_ids.push( vid_id );

          } );

          for( let vid_id of vid_ids ) {

            let Player = new YT.Player( vid_id, {

              playerVars: {
                //'autoplay' : 1,
                'rel' : 0,
                'enablejsapi' : 1,
                'loop' : 1,
                'controls' : 0,
                'modestbranding' : 1,
                'showinfo' : 0,
                'playlist' : vid_id
              },
              videoId : vid_id,
              events: {
                'onReady' : prepYoutubePlayer
              }

            });

          }
        }

        /**
        * Prepare youtube player
        */
        function prepYoutubePlayer( event ) {

          event.target.mute();
          event.target.playVideo();

        }


        /**
         * Load Vimeo video
        */
        function loadVimdeoVideo( $container ) {


        }

    }



 } )( );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/media.js